
import { Component, Vue, Prop} from 'vue-property-decorator';
import { namespace } from "vuex-class";   

import "@/store/modules/application";
const applicationState = namespace("Application");

import StepBase from "../StepBase.vue";
import RequestForScheduling from "./RequestForScheduling.vue";
import ReasonForScheduling from "./ReasonForScheduling.vue";
import InterimOrder from "./InterimOrder.vue";
import NextAppearance from "./NextAppearance.vue";
import PartyInformationRqs from "./PartyInformationRQS.vue";
import ReviewYourAnswersRqs from "./reviewRQS/ReviewYourAnswersRQS.vue";
import PreviewFormsRqs from "./reviewRQS/PreviewFormsRQS.vue";

import { stepInfoType } from "@/types/Application";
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages";

@Component({
    components:{
        StepBase,        
        RequestForScheduling,        
        ReasonForScheduling,
        InterimOrder,
        NextAppearance,
        PartyInformationRqs,
        ReviewYourAnswersRqs,
        PreviewFormsRqs        
    }
})
export default class RequestSchedulingStep extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

}
